import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

export const VendorSchema = yup.object({
  name: yup.string().required(REQUIRED_MESSAGE),
  industry: yup.string(),
  vendorFacilityAddressLine2: yup.string().nullable(),
  vendorKeywords: yup.array(yup.string()),
  vendorId: yup.string(),
})

export type TVendorSchema = yup.InferType<typeof VendorSchema>
